import { Chart as ChartJS } from 'chart.js';
import 'chartjs-adapter-date-fns';
import annotationPlugin from 'chartjs-plugin-annotation';
import zoomPlugin from 'chartjs-plugin-zoom';

ChartJS.register(annotationPlugin, zoomPlugin);

const getChartOptions = ({
    yAxisLabel,
    yAxisMin,
    yAxisMax,
    yAxisDecimals,
    handleZoom,
    xAxisLabel = 'datetime',
    showLegends = true,
    now = Date.now()
}) => {
    const yTicks = {
        color: '#ddd',
        format: { maximumFractionDigits: 6 },
        maxTicksLimit: 8,
    };

    if (typeof yAxisDecimals !== 'undefined' && yAxisDecimals !== null) {
        yTicks.callback = function(value) {
            return Number(value).toFixed(yAxisDecimals);
        };
    }

    return {
        maintainAspectRatio: false,
        scales: {
            x: {
                type: 'time',
                time: {
                    tooltipFormat: 'yyyy-MM-dd HH:mm',
                    displayFormats: {
                        hour: 'MMM dd, HH:mm',
                        minute: 'MMM dd, HH:mm'
                    }
                },
                ticks: {
                    color: '#ddd'
                },
                grid: { color: '#555' },
                title: {
                    display: true,
                    text: xAxisLabel,
                    color: '#ddd',
                    font: { size: 14 }
                }
            },
            y: {
                min: yAxisMin,
                max: yAxisMax,
                ticks: yTicks,
                grid: { color: '#555' },
                title: { display: true, text: yAxisLabel, color: '#ddd', font: { size: 14 } },
            }
        },
        plugins: {
            legend: {
                display: showLegends,
                position: 'top',
                labels: {
                    color: '#ddd',
                    font: { size: 14 }
                }
            },
            tooltip: {
                callbacks: {
                    title: function (tooltipItems) {
                        return tooltipItems[0].label;
                    },
                },
            },
            annotation: {
                clip: true,
                annotations: {
                    now: {
                        type: 'line',
                        scaleID: 'x',
                        value: now,
                        adjustScaleRange: false,
                        borderColor: 'red',
                        borderWidth: 2,
                    }
                }
            },
            zoom: {
                pan: {
                    enabled: true,
                    mode: 'x',
                },
                zoom: {
                    wheel: {
                        enabled: false, // ❌ Disable zooming with mouse wheel
                    },
                    drag: {
                        enabled: true, // ✅ Enable zoom by dragging a box
                        modifierKey: 'ctrl', // optional: remove if you want to require Shift/Ctrl
                    },
                    mode: 'x',
                    onZoomComplete: ({ chart }) => {
                        const range = chart.scales.x;
                        const start = range.min;
                        const end = range.max;
                        handleZoom(start, end);
                    },
                },
            }
            
        },
    };
};

export default getChartOptions;
